import React from 'react';

const FaceBookIcon = props => (
  <svg
    {...props}
    x="0px"
    y="0px"
    width={20}
    height={20}
    viewBox="0 0 612 612"
    style={{ enableBackground: 'new 0 0 612 612' }}
  >
    <g>
      <path
        fill="#3f3f3f"
        d="M612,306C612,137.004,474.995,0,306,0C137.004,0,0,137.004,0,306c0,168.995,137.004,306,306,306
			C474.995,612,612,474.995,612,306z M27.818,306C27.818,152.36,152.36,27.818,306,27.818S584.182,152.36,584.182,306
			S459.64,584.182,306,584.182S27.818,459.64,27.818,306z"
      />
      <path
        fill="#3f3f3f"
        d="M317.739,482.617V306h58.279l9.208-58.529h-67.487v-29.348c0-15.272,5.007-29.849,26.928-29.849h43.813v-58.418h-62.201
			c-52.298,0-66.569,34.438-66.569,82.175v35.413h-35.885V306h35.885v176.617H317.739L317.739,482.617z"
      />
    </g>
  </svg>
);
export default FaceBookIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/FaceBook.js